// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Typography from "@sothebys/sterling/typography";

var make = Typography.Paragraph12LinkRegular;

var Paragraph12LinkRegular = {
  make: make
};

var make$1 = Typography.Paragraph12Regular;

var Paragraph12Regular = {
  make: make$1
};

var make$2 = Typography.Paragraph14LinkRegular;

var Paragraph14LinkRegular = {
  make: make$2
};

var make$3 = Typography.Paragraph14Regular;

var Paragraph14Regular = {
  make: make$3
};

var make$4 = Typography.Paragraph16LinkRegular;

var Paragraph16LinkRegular = {
  make: make$4
};

var make$5 = Typography.Paragraph16Regular;

var Paragraph16Regular = {
  make: make$5
};

var make$6 = Typography.Paragraph18LinkRegular;

var Paragraph18LinkRegular = {
  make: make$6
};

var make$7 = Typography.Paragraph18Regular;

var Paragraph18Regular = {
  make: make$7
};

var make$8 = Typography.Label12Medium;

var Label12Medium = {
  make: make$8
};

var make$9 = Typography.Label14Medium;

var Label14Medium = {
  make: make$9
};

var make$10 = Typography.Label16Medium;

var Label16Medium = {
  make: make$10
};

var make$11 = Typography.Label18Medium;

var Label18Medium = {
  make: make$11
};

var _map = {"h1":"h1","h2":"h2","h3":"h3","h4":"h4","h5":"h5","h6":"h6"};

function headlineTypeToJs(param) {
  return param;
}

function headlineTypeFromJs(param) {
  return _map[param];
}

var make$12 = Typography.Headline20Regular;

var Headline20Regular = {
  make: make$12
};

var make$13 = Typography.Headline24Regular;

var Headline24Regular = {
  make: make$13
};

var make$14 = Typography.Headline28Regular;

var Headline28Regular = {
  make: make$14
};

var make$15 = Typography.Headline32Regular;

var Headline32Regular = {
  make: make$15
};

var make$16 = Typography.Headline48Regular;

var Headline48Regular = {
  make: make$16
};

var make$17 = Typography.Headline64Regular;

var Headline64Regular = {
  make: make$17
};

var make$18 = Typography.Caps12Medium;

var Caps12Medium = {
  make: make$18
};

var make$19 = Typography.Caps14Medium;

var Caps14Medium = {
  make: make$19
};

var make$20 = Typography.ButtonLink12Regular;

var ButtonLink12Regular = {
  make: make$20
};

var make$21 = Typography.ButtonLink14Regular;

var ButtonLink14Regular = {
  make: make$21
};

var make$22 = Typography.ButtonLink16Regular;

var ButtonLink16Regular = {
  make: make$22
};

var make$23 = Typography.ButtonLink18Regular;

var ButtonLink18Regular = {
  make: make$23
};

var make$24 = Typography.Button14Medium;

var Button14Medium = {
  make: make$24
};

export {
  Paragraph12LinkRegular ,
  Paragraph12Regular ,
  Paragraph14LinkRegular ,
  Paragraph14Regular ,
  Paragraph16LinkRegular ,
  Paragraph16Regular ,
  Paragraph18LinkRegular ,
  Paragraph18Regular ,
  Label12Medium ,
  Label14Medium ,
  Label16Medium ,
  Label18Medium ,
  headlineTypeToJs ,
  headlineTypeFromJs ,
  Headline20Regular ,
  Headline24Regular ,
  Headline28Regular ,
  Headline32Regular ,
  Headline48Regular ,
  Headline64Regular ,
  Caps12Medium ,
  Caps14Medium ,
  ButtonLink12Regular ,
  ButtonLink14Regular ,
  ButtonLink16Regular ,
  ButtonLink18Regular ,
  Button14Medium ,
}
/* make Not a pure module */
